<template>
  <div
    class="pt-2 mb-4 slide-image transition-instruction-bar"
    :class="{
      'has-bg-image': slideActive.backgroundImage,
      'n-caption': !slideActive.title || slideActive.title == ' ',
    }"
  >
    <div class="flex image-body">
      <iframe
        width="1048.89"
        v-if="id"
        height="600"
        :src="id"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        id="youtube-iframe"
        class="youtube-iframe"
      />
    </div>
    <div
      class="p-0 caption"
      v-if="hasSlideActiveTitle"
      :class="{
        'small-text': slideActive.title && slideActive.title.length > 64
      }"
    >
      <SlideTitleEditor
        class="p-0 youtube-caption-text"
        :class="{'has-background': hasSlideActiveTitle}"
        type="slide-title"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Util from '@/util'
import SlideTitleEditor from '@/components-v2/presentation-editor/middle/SlideTitleEditor.vue'

export default {
  components: {
    SlideTitleEditor,
  },
  data() {
    return {
      id: '',
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    hasSlideActiveTitle() {
      return this.slideActive.title && this.slideActive.title.trim().length
    },
  },
  watch: {
    '$store.state.slideActive': function () {
      this._getYouTubeLink()
    },
  },
  mounted() {
    this._getYouTubeLink()
  },

  methods: {
    _getYouTubeLink() {
      if (
        this.$store.state.slideActive.youtubeLink &&
        Util.isURL(this.$store.state.slideActive.youtubeLink)
      ) {
        const id = Util.getParamValue('v', this.$store.state.slideActive.youtubeLink)
        if (id) {
          this.id = `https://www.youtube.com/embed/${id}`
        } else {
          const embedIndex = this.$store.state.slideActive.youtubeLink.indexOf('/embed/')
          if (embedIndex != -1) {
            this.id = this.$store.state.slideActive.youtubeLink
          } else {
            this.id = ''
          }
        }
      } else {
        this.id = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.has-bg-image {
  .caption {
    color: #fff;
  }

  .youtube-caption-text {
    &::v-deep p {
      width: fit-content;
      border-radius: 50px;
    }
    &.has-background::v-deep p {
      background-color: #00000061;
    }
  }
}
.caption {
  display: flex;
  justify-content: center;
  &::v-deep p {
    padding: 8px 16px;
  }
}

.image-body {
  overflow: hidden;
  padding-top: 42.1875%;
  position: relative;
  margin-bottom: 0.5rem;
  .youtube-iframe {
    position: absolute;
    top: 0;
    left: 12.4%;
    border: 0;
    height: 100%;
    width: 75%;
  }
}

.n-caption {
  .image-body .youtube-iframe {
    width: 88%;
    left: 6%;
  }
}

@media (max-width: 768px) and (orientation: landscape) {
  .image-body {
    padding-top: 36.569%;
  }
}
</style>
